import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BarcodePrinterComponent } from './barcode-printer.component';
import { NgxBarcode6Module } from 'ngx-barcode6';

@NgModule({
  declarations: [BarcodePrinterComponent],
  imports: [
    CommonModule,
    NgxBarcode6Module
  ],
  exports: [
    BarcodePrinterComponent
  ]
})

export class BarcodePrinterModule { }
